import { render } from "./Movimientos.vue?vue&type=template&id=3454a89a&scoped=true"
import script from "./Movimientos.vue?vue&type=script&lang=js"
export * from "./Movimientos.vue?vue&type=script&lang=js"

import "./Movimientos.vue?vue&type=style&index=0&id=3454a89a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3454a89a"]])

export default __exports__